import { formatMoney } from '@betterment/core';
import { Box, Link, ListRow, Separator, Text } from '@betterment/samba-react';

import { IntCoordinatedAccountsCardQuery } from './graphql/coordinatedAccountsCard.generated';

import { Client, LegalAccountTaxationType } from '../../../graphql/schema';
import urlBuilder from '../../../Shared/url-builder';
import { ImpersonationLink } from '../ImpersonationLink';

type ManagedAccount = Extract<IntCoordinatedAccountsCardQuery['envelopeAccount'], { __typename: 'ManagedAccount' }>;

export type ManagedSubAccount = ManagedAccount['subAccounts'][number];

type Props = {
  subAccount: ManagedSubAccount;
  householdId: string;
  colorMode: 'light' | 'dark';
};

function rowLink(
  taxationType: LegalAccountTaxationType,
  subAccountId: number,
  householdId: string,
  users: Pick<Client, 'id'>[]
) {
  switch (taxationType) {
    case LegalAccountTaxationType.TraditionalIra:
      return (
        <Link href={urlBuilder.getHouseholdConvertFundsToRoth({ householdId, subAccountId })}>Convert to Roth</Link>
      );
    case LegalAccountTaxationType.RothIra:
      return (
        <ImpersonationLink
          showModal={false}
          url={urlBuilder.getImpersonateClientPage.absolute({
            clientId: users[0].id,
            deep_link_path: `/ira_recharacterizations`,
          })}
          label="Recharacterize contribution"
          variant="textPrimary"
        />
      );
    default:
      return null;
  }
}

export const CoordinatedAccountRow: React.FC<Props> = ({ subAccount, householdId, colorMode }) => {
  return (
    <Box>
      <Separator css={{ fullWidthWithInset: 'space.300' }} />
      <ListRow css={{ color: 'text' }}>
        <ListRow.LeadingAsset>
          <Box css={{ width: 'size.450', height: 'size.450' }}>
            <img src={subAccount.icon[colorMode]} alt="" />
          </Box>
        </ListRow.LeadingAsset>
        <ListRow.LeadingContent>
          <Text>{subAccount.name}</Text>
        </ListRow.LeadingContent>
        {subAccount.balance && (
          <ListRow.TrailingContent>
            <Text>{formatMoney(subAccount.balance)}</Text>
            {rowLink(
              subAccount.legalAccount.taxationType,
              subAccount.legacySubAccountId,
              householdId,
              subAccount.users
            )}
          </ListRow.TrailingContent>
        )}
      </ListRow>
    </Box>
  );
};
